import { useContext } from 'react';
import { LocalizationContext } from './context';
export function useTranslations() {
    var context = useContext(LocalizationContext);
    return [context.translations, context.locale];
}
//# sourceMappingURL=useTranslations.js.map